import * as React from 'react';
import { Control, useController } from 'react-hook-form';
import { CmdError } from '@commander-services/gui-components';
import { useIntl } from 'react-intl';

export interface IRadioInputHookFormValue {
  item: string;
  value: string | number;
  id?: string;
  checked?: boolean;
  item2?: string;
}

interface IRadioInputHookFormProps {
  label: string;
  name: string;
  id: string;
  options: IRadioInputHookFormValue[];
  control: Control<any>;
  // placeholder?: string;
  width?: string;
  // readonly?: boolean;
  required?: boolean;
  rowOrRows?: string;
  disabled?: boolean;
  className?: string;
  tooltip?: string;
  warningMessage?: string;
  columnClass?: string;
  isGrid?: boolean;
  onChangeCallback?: (value: any) => void;
  tooltipByValue?: { [key: string]: string };
}

export function RadioInputHookForm(props: IRadioInputHookFormProps): JSX.Element {
  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { invalid, error },
  } = useController({
    name: props.name,
    control: props.control,
    defaultValue: '', // or the default value
  });
  const rowOrRowsClass = props.rowOrRows === 'rows' ? 'd-block' : 'd-inline-block';
  const rowOrRows = props.rowOrRows ? props.rowOrRows : 'row';
  const { formatMessage: f } = useIntl();

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    onChange(inputValue);
    if (props.onChangeCallback) {
      props.onChangeCallback(inputValue);
    }
  };

  let errBorder = '';
  if (error) {
    errBorder = 'err-border';
  }

  let radioHeader: JSX.Element = <></>;
  let leftMargin = 'ml-1';
  if (rowOrRows === 'rows') {
    leftMargin = 'ml-5';
    radioHeader = (
      <div className="row">
        <div className={props.width}>
          <div className="text-left control-label">
            <b>
              {props.required && (
                <span className="text-danger text-danger required-field-info">* </span>
              )}
              {props.label}
            </b>
          </div>
        </div>
      </div>
    );
  }
  let radioGroupWidth = '';
  let radioLabel: JSX.Element = <></>;
  if (rowOrRows === 'row') {
    radioGroupWidth = props.width ? props.width : 'col-9';
    radioLabel = (
      <div className="col-3">
        <div className="mt-1">
          <b>
            {props.required && (
              <span className="text-danger text-danger required-field-info">* </span>
            )}
            {props.label}
          </b>
        </div>
      </div>
    );
  }

  return (
    <div className={`radio-input-component form-group ${error && 'form-group-error'}`}>
      <div>
        <label className="d-block form-label">
          {props.required && <span className="text-danger required-field-info">*</span>}
          {props.label}
        </label>
        <div className="d-block">
          <div
            className={props.isGrid ? '' : 'row'}
            title={props.tooltip || ''}
            style={
              props.isGrid
                ? {
                    display: 'grid',
                    gridTemplateRows: 'repeat(2, max-content)',
                    gridTemplateColumns: '1fr 1fr',
                  }
                : {}
            }
          >
            {Object.values(props.options).map((option: IRadioInputHookFormValue, index: number) => (
              <div
                className={`${props.isGrid ? '' : props.columnClass || 'col-3'}`}
                key={`radio-input-${props.id}-${index}`}
              >
                <div className="e-radio">
                  <label
                    data-cy={`radio-button-${option.value}`}
                    data-option-value={option.value}
                    data-disabled-value={props.disabled}
                    htmlFor={option.id}
                    title={
                      props.tooltipByValue && props.tooltipByValue[option.value]
                        ? f({ id: `${props.tooltipByValue[option.value]}` })
                        : ''
                    }
                  >
                    <input
                      // {...field}
                      type="radio"
                      name={props.name}
                      value={String(option.value)}
                      className={props.className || ''}
                      checked={value === String(option.value)}
                      disabled={props.disabled}
                      id={`radio-${props.name}-${index}`}
                      onChange={handleOnChange}
                    />
                    <span style={{ fontSize: '13px' }}>{String(option.item)}</span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        {error && <CmdError message={error?.message} />}
        {props.warningMessage && <CmdError message={props.warningMessage} />}
      </div>
    </div>
  );
}
